<form class="flex flex-col gap-4" [formGroup]="form">
  <div class="flex flex-col gap-1">
    <h3 class="!m-0 !font-bold">Enrolment Report</h3>

    @if (customReport(); as report) {
      <pr-campaign-report-summary [customReport]="report">
        This report will be used to enroll entries in the Campaign Run.
      </pr-campaign-report-summary>
    } @else {
      <pr-file-upload-summary />
    }
  </div>

  <div class="flex flex-col gap-1">
    <h3 class="!m-0 !font-bold">Entries Per Run</h3>
    <div>
      Leftover entries stay in preview. You can move them to a new run or remove
      them. Recurring campaigns approve old entries before new ones.
    </div>
    <mat-form-field subscriptSizing="dynamic" floatLabel="always" class="pt-2">
      <mat-label>Maximum Entries Per Run</mat-label>
      <mat-select
        formControlName="maximumEntriesPerRun"
        placeholder="Unlimited"
      >
        <mat-option [value]="undefined">Unlimited</mat-option>
        @for (option of maxEntriesPerRun; track option) {
          <mat-option [value]="option">
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex flex-col gap-1">
    <h3 class="!m-0 !font-bold">Automatic Campaign</h3>
    @if (!customReport()) {
      <pr-information-box theme="info">
        Select a Custom Report to configure a Recurring Campaign
      </pr-information-box>
    }

    <mat-checkbox
      color="primary"
      [checked]="form.value.isRecurring"
      (change)="form.controls.isRecurring.setValue($event.checked)"
    >
      Create a Campaign Run to enrol new entries on a schedule.
    </mat-checkbox>

    @if (form.value.isRecurring) {
      <pr-recurrence-form
        #recurrenceForm
        class="pt-2"
        [showButtons]="false"
        [recurrencePattern]="form.controls.recurrencePattern.value"
        (formChange)="updateRecurrenceSettings($event)"
      >
        <div class="time-selector flex items-center gap-4">
          <div class="text-xl">&commat;</div>
          <pt-iso-time-selector
            class="w-48"
            label="Time of day"
            floatLabel="always"
            formControlName="recurrenceRunTime"
          />
        </div>
      </pr-recurrence-form>
    }
  </div>
</form>
